import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/config/site";

// Gère title, meta description, canonical, Open Graph et données structurées JSON-LD.
export const Seo = ({ title, description, path, jsonLd, noindex = false }) => {
  const location = useLocation();
  const url = SITE.url + (path || location.pathname);

  useEffect(() => {
    if (title) document.title = title.replace(/FRELONS50(?!™)/g, "FRELONS50™");

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    // Canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    // JSON-LD
    const existing = document.head.querySelectorAll('script[data-seo-jsonld="true"]');
    existing.forEach((s) => s.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach((obj) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-jsonld", "true");
        script.text = JSON.stringify(obj);
        document.head.appendChild(script);
      });
    }
  }, [title, description, url, jsonLd, noindex]);

  return null;
};

// Données structurées LocalBusiness / ProfessionalService réutilisables.
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "PestControlService",
  name: "FRELONS50",
  legalName: "Ludovic Vandoolaeghe",
  description: SITE.tagline,
  telephone: "+33635922149",
  email: SITE.email,
  url: SITE.url,
  image: SITE.url + "/images/hero-rural.webp",
  logo: SITE.url + "/logo-icon.png",
  areaServed: { "@type": "AdministrativeArea", name: "Manche, Normandie, France" },
  address: {
    "@type": "PostalAddress",
    streetAddress: "5 route de Mortain",
    postalCode: "50640",
    addressLocality: "Le Teilleul",
    addressRegion: "Manche",
    addressCountry: "FR",
  },
  openingHours: "Mo-Su 00:00-23:59",
  priceRange: "€€",
};
